import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { getUserLocks, getRecipientFriendList } from "./MemberManagementHelper";
import { customLog } from "../../variables/Variables";
import { fire, auth } from "../../firebase/index";
import LocalizedStrings from "react-localization";
import AddRecipient from "./AddRecipient";
//import localization
//Localization codes
let localizationStrings = new LocalizedStrings({
  en: {
    userInfoTitle: "User Info",
    serialNoTitle: "Serial No.",
    lockNameTitle: "Lock Name",
    lockBelongsToTitle: "Shared by",
    showInfoButton: "Show Info",
    loadingText: "loading...",
    noLocksText: "No locks found",
    noRecipientsText: "No recipients found",
    recipientHeader: "Recipients",
    lockHeader: "Locks",
    recipientEmailTitle: "Recipient Email",
    recipientNameTitle: "Recipient Name",
  },
  ja: {
    userInfoTitle: "メンバー詳細",
    serialNoTitle: "シリアルナンバー",
    lockNameTitle: "ロック名称",
    lockBelongsToTitle: "共有者",
    showInfoButton: "情報を表示",
    loadingText: "loading...",
    noLocksText: "ロックのデータがありません。",
    noRecipientsText: "受取人が見つかりません",
    recipientHeader: "共有先リスト",
    lockHeader: "スマートロック",
    recipientEmailTitle: "共有者メールアドレス",
    recipientNameTitle: "共有者名",
  },
  es: {
    userInfoTitle: "Información del Usuario",
    serialNoTitle: "Número de Serie",
    lockNameTitle: "Nombre del Candado",
    lockBelongsToTitle: "Compartido por",
    showInfoButton: "Mostrar Información",
    loadingText: "loading...",
    noLocksText: "No se encontraron candados",
    noRecipientsText: "No se encontraron destinatarios",
    recipientHeader: "Destinatarios",
    lockHeader: "Candados",
    recipientEmailTitle: "Correo Electrónico del Destinatario",
    recipientNameTitle: "Nombre del Destinatario",
  },
});

export class DetailsButton extends Component {
  constructor(props) {
    super(props);

    this.showInfoClicked = this.showInfoClicked.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onAfterDeleteRow = this.onAfterDeleteRow.bind(this);
    this.customConfirmDialog = this.customConfirmDialog.bind(this);

    const cell = this.props.cellValue;
    const row = this.props.rowValue;
    const memberName = this.props.memberName;

    this.state = {
      cell: cell,
      row: row,
      memberName: memberName,
      userLocks: [],
      noDataText: localizationStrings.loadingText,
      noDataTextRecipient: localizationStrings.loadingText,
      showPopup: false,
      loading: false,
    };
  }

  componentWillMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }
  }

  async showInfoClicked() {
    this.setState({ showPopup: true });
    customLog(this.state.cell);
    customLog(this.state.row);

    const memberDetails = this.state.row;
    const memberEmail = memberDetails.memberEmail;
    customLog(memberEmail);

    //setstate for user locks

    const userLocks = await getUserLocks(memberEmail);

    this.setState({ userLocks: userLocks });

    if (userLocks.length <= 0) {
      this.setState({ noDataText: localizationStrings.noLocksText });
    }

    //setstate for friend list

    const { userId, ReceipientFriendList } = await getRecipientFriendList(
      memberEmail
    );

    this.setState({
      userRecipientList: ReceipientFriendList,
      userId: userId,
    });
    if (ReceipientFriendList.length <= 0) {
      this.setState({
        noDataTextRecipient: localizationStrings.noRecipientsText,
      });
    }
  }

  handleClose() {
    this.setState({ showPopup: false });
  }

  customConfirmDialog(next) {
    next();
  }

  onAfterDeleteRow(rowKeys) {
    //"A111111"
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    //! FOR LANGUAGE SETTING
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const columnHover = (cell, row, enumObject, rowIndex) => {
      return cell;
    };

    return (
      <div>
        <Modal
          show={this.state.showPopup}
          onHide={this.handleClose}
          dialogClassName="responsive-modal"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {localizationStrings.userInfoTitle +
                " - " +
                this.state.memberName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <br />
            <Tabs defaultIndex={0}>
              <TabList>
                <Tab>{localizationStrings.recipientHeader}</Tab>

                <Tab>{localizationStrings.lockHeader}</Tab>
              </TabList>

              <TabPanel>
                <BootstrapTable
                  pagination
                  // deleteRow={true}
                  // selectRow={{ mode: "checkbox" }}
                  data={this.state.userRecipientList}
                  options={{
                    // sizePerPage: 5,
                    sizePerPage: 10,
                    hideSizePerPage: true,
                    noDataText: this.state.noDataTextRecipient,
                    // afterDeleteRow: this.onAfterDeleteRow,
                    // handleConfirmDeleteRow: this.customConfirmDialog
                  }}
                >
                  <TableHeaderColumn
                    dataField="friendName"
                    columnTitle={columnHover}
                  >
                    {localizationStrings.recipientNameTitle}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    isKey={true}
                    dataField="friendEmail"
                    columnTitle={columnHover}
                  >
                    {localizationStrings.recipientEmailTitle}
                  </TableHeaderColumn>
                </BootstrapTable>
                <AddRecipient memberEmail={this.state.row.memberEmail} />
              </TabPanel>

              <TabPanel>
                <BootstrapTable
                  pagination
                  // deleteRow={true}
                  // selectRow={{ mode: "checkbox" }}
                  data={this.state.userLocks}
                  options={{
                    // sizePerPage: 5,
                    sizePerPage: 10,
                    hideSizePerPage: true,
                    noDataText: this.state.noDataText,
                    // afterDeleteRow: this.onAfterDeleteRow,
                    // handleConfirmDeleteRow: this.customConfirmDialog
                  }}
                >
                  <TableHeaderColumn
                    isKey={true}
                    dataField="ip45SerialNumber"
                    columnTitle={columnHover}
                  >
                    {localizationStrings.serialNoTitle}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="status"
                    columnTitle={columnHover}
                  >
                    {localizationStrings.lockBelongsToTitle}
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="Name" columnTitle={columnHover}>
                    {localizationStrings.lockNameTitle}
                  </TableHeaderColumn>
                </BootstrapTable>
              </TabPanel>
            </Tabs>
          </Modal.Body>
        </Modal>

        <Button
          onClick={this.showInfoClicked}
          className="btn btn-info"
          style={{ borderRadius: "50px" }}
        >
          {localizationStrings.showInfoButton}
        </Button>
      </div>
    );
  }
}

export default DetailsButton;
